import { ServiceState } from "@wingspanhq/users/dist/lib/interfaces/enabledServices";
import { Benefit } from "../data";

export type BenefitPrimaryAction =
  /** No toolbar button — the sidebar CTA and contact details take over. */
  | { kind: "none" }
  | { kind: "external"; label: string; url: string }
  | { kind: "pending"; label: string };

/**
 * The detail page's primary call to action.
 *
 * Benefits sold outside the Wingspan membership (their cost is not covered,
 * or is not shown at all) hand off to the sidebar CTA instead.
 */
export const selectorBenefitPrimaryAction = (params: {
  benefit: Benefit;
  serviceState?: ServiceState;
}): BenefitPrimaryAction => {
  const { benefit, serviceState } = params;

  if (benefit.customEnrollLink) {
    return {
      kind: "external",
      label: "Enroll now",
      url: benefit.customEnrollLink
    };
  }

  if (benefit.costIsNotIncluded || benefit.hideCost) {
    return { kind: "none" };
  }

  if (serviceState === ServiceState.Pending) {
    return { kind: "pending", label: "Pending" };
  }

  return { kind: "none" };
};
